export class MapUtil {

    static  extractStringArray(keys:IterableIterator<string> ):string[] {
       return Array.from(keys);
    }

}
